import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select.tsx'
import { toDateString } from '@/utils/date.ts'
import { ChevronDown } from 'lucide-react'

type Props = {
  iterations: IterationSummary[]
  setSelectedIteration: (iteration?: IterationSummary) => void
}

export const IterationSelector = ({ iterations, setSelectedIteration }: Props) => {
  const currentIteration = iterations?.[iterations.length - 1]

  return (
    <Select
      defaultValue={currentIteration?.number.toString()}
      onValueChange={(value) => setSelectedIteration(iterations.find((i) => i.number === +value))}
    >
      <SelectTrigger className="flex h-6 w-[138px] bg-[#456580] border-[#456580] rounded text-white pl-1 pr-0 py-0 p-1 ">
        <SelectValue placeholder="Select iteration" className="font-EN-KR-caption-regular" />
        <ChevronDown className="h-3.5 w-3.5 text-contents-accent" />
      </SelectTrigger>
      <SelectContent className="font-EN-KR-caption-regular rounded-sm max-h-[156px]">
        {iterations.toReversed().map((option) => (
          <SelectItem key={option.number} value={option.number.toString()} className="px-[6px] py-2">
            {`${toDateString(option.start)} - ${toDateString(option.finish)} (${currentIteration?.number === option.number ? 'current' : `#${option.number}`})`}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  )
}
